module.exports = __webpack_public_path__ + "img/SIDEBAR_Nachtrag.338a160b.svg";